// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// Mint-ui
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
// 解决300毫秒问题
import fastClick from 'fastclick'
import 'babel-polyfill'
// 多语言翻译插件
import i18n from '@/common/lang'

// vuex数据管理
import store from '@/data/store'

// Mock数据服务
import '@/data/mock'

// 监听全局系统错误
import '@/common/utils/errorLog'

// 引入全局样式
import '@/assets/styles/index.styl'

// 权限管理
import '@/common/permission'

// 全局directive
import * as directives from '@/common/directives'

// 全局Filters
import * as filters from '@/common/filters'

// 引入正则校验
import Validate from '@/common/validate/index.js'

/* 引入Progress 进度条 */
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

/* eslint-disable no-unused-vars */
// import('@/common/utils/vconsole.js')

import vueLazyload from 'vue-lazyload'

// 导入全局图片的Lazyload
Vue.use(vueLazyload)

// 导入全局Filters方法
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 全局验证
Vue.use(Validate)

// 导入全局指令方法
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

// 禁止vue启动错误提示
Vue.config.productionTip = false

fastClick.attach(document.body)

router.beforeEach((to, from, next) => {
  // 解决在微信中分享好友，微信自己加了一些参数，导致链接被破坏问题
  let ua = (navigator.userAgent).toLowerCase()
  if (ua.indexOf('micromessenger') > 0 && window.location.href.indexOf('?#') < 0) {
    window.location.href = window.location.href.replace('#', '?#')
  }
  NProgress.start()
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
router.afterEach((to, from) => {
  NProgress.done()
})

// 实例化Mint-ui
Vue.use(Mint, {
  size: 'medium',
  i18n: (key, value) => i18n.t(key, value)
})
Vue.prototype.$mint = Mint

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js